(($, win) => {
    "use strict";

    $.enhancer("querySearchOverlay",
        {
            settings: {
                mediaQuery: "(min-width: 768px)",
                minQueryCharLength: 2,
                maxNumOfListItems: 5,
                element: null,
                initialized: false,
                isLoading: false
            },
            searchOverlay: null,
            init: function (el) {

                const mediaQuery = win.matchMedia(this.settings.mediaQuery);

                mediaQuery.addListener((e) => {
                    if (!this.settings.initialized && !e.matches) {
                        this.load(el);
                        this.bindEvents();
                    }
                    this.settings.initialized = true;
                });

                if (!this.settings.initialized && !mediaQuery.matches) {
                    this.load(el);
                    this.bindEvents();
                    this.settings.initialized = true;
                }

            },
            load: function (el) {
                this.element = $(el);
                this.searchOverlay = new SearchOverlay(el);
            },
            bindEvents: function () {
                this.settings.initialized = true;
                this.searchOverlay.input.on("keyup", $.utils.debounce(this.handleInput, 300, this));
                this.searchOverlay.searchPanel.on("click", "a", $.proxy(this.handleElementClick, this));
                this.searchOverlay.listPanel.on("click", "a", $.proxy(this.handleElementClick, this));
            },
            handleInput: function (e) {


                // Handle arrow down from the input
                if (e.keyCode === 40 && this.searchOverlay.input.is(":focus")) {
                    this.searchOverlay.searchPanel.find("a").first().focus();
                    return;
                }

                const query = e.currentTarget.value.trim();
                if (query !== $("#search-query").val()) {
                    $(".search-course").val("false");
                }

                const requestUrl = this.searchOverlay.searchOverlay.attr("data-serviceurl").replace("{query}", query);

                // Handle enter
                if (e.keyCode === 13 && this.searchOverlay.input.is(":focus")) {
                    $("#search-query").val(query);
                    $("#search-mobile-form").submit();
                    return;
                }


                this.searchOverlay.form.find("[name=query]").val(query);

                // Show/hide results when filtering from input
                if (query.length >= this.settings.minQueryCharLength) {

                    this.settings.isLoading = true;
                    this.searchOverlay.toggleLoadingIndicator(true);

                    this.searchOverlay.searchPanel.empty();

                    $.ajax({
                        url: requestUrl
                    }).then((data) => {
                        const topicTemplate = this.searchOverlay.searchOverlay.find(".topic-template").clone();
                        const arrangementTemplate =
                            this.searchOverlay.searchOverlay.find(".arrangement-template").clone();
                        let count = 0;

                        this.settings.isLoading = false;
                        this.searchOverlay.toggleLoadingIndicator(false);

                        this.searchOverlay.searchPanel.empty();

                        for (let i = 0, arrangement; i < this.settings.maxNumOfListItems && i < data.arrangements.length; i++) {
                            if (i === 0) {
                                let arrangementHeader = this.searchOverlay.searchOverlay
                                    .find(".search-box-header-arrangement").clone();
                                arrangementHeader.removeClass("search-box-header-arrangement").show()
                                    .appendTo(this.searchOverlay.searchPanel);
                            }
                            arrangement = data.arrangements[i];

                            const formatedText = $.utils.replaceString(arrangement.Text, query, `<b style='pointer-events: none;'>$&</b>`);
                            arrangementTemplate.clone().removeClass("arrangement-template")
                                .html(formatedText).attr("href", arrangement.Url).show()
                                .appendTo(this.searchOverlay.searchPanel);
                            count++;
                        }

                        for (let i = 0, topic; i < this.settings.maxNumOfListItems && i < data.topics.length; i++) {
                            if (i === 0) {
                                let topicHeader = this.searchOverlay.searchOverlay.find(".search-box-header-topic")
                                    .clone();
                                topicHeader.removeClass("search-box-header-topic").show()
                                    .appendTo(this.searchOverlay.searchPanel);
                            }
                            topic = data.topics[i];
                            const formatedText = $.utils.replaceString(topic.Text, query, `<b style='pointer-events: none;'>$&</b>`);
                            topicTemplate.clone().removeClass("topic-template").html(formatedText)
                                .attr("href", topic.Url).show()
                                .appendTo(this.searchOverlay.searchPanel);
                            count++;
                        }

                        if (count === 0) {
                            this.searchOverlay.searchPanel.append(
                                `<a class="dropdown-item"><i>Inga träffar för ${query}<i></a>`);
                        }

                    });

                    this.searchOverlay.showPanel(this.searchOverlay.searchPanel);
                    this.searchOverlay.hidePanel(this.searchOverlay.listPanel);

                } else {
                    this.searchOverlay.showPanel(this.searchOverlay.listPanel);
                    this.searchOverlay.hidePanel(this.searchOverlay.searchPanel);
                }

            },
            handleElementClick: function (e) {

                if ($(e.target).hasClass("course-item")) {
                    e.preventDefault();
                    const selectedElement = $(e.target);
                    const searchText = selectedElement.text().trim();
                    this.searchOverlay.input.val(searchText);
                    $(".search-course").val("true");
                    $("#search-query").val(searchText);
                    this.searchOverlay.hideOverlay();
                    return;
                }
            }

        });

})(jQuery, window);
